module.exports = __webpack_public_path__ + "img/banner_mobile.77dacd4c.png";